import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=32c23186&scoped=true"
import script from "./NewCampaign.vue?vue&type=script&lang=js"
export * from "./NewCampaign.vue?vue&type=script&lang=js"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=32c23186&prod&scoped=true&lang=css"
import style1 from "./NewCampaign.vue?vue&type=style&index=1&id=32c23186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c23186",
  null
  
)

export default component.exports